import { createActionGroup, props } from '@ngrx/store';
import {
    BackgroundJobCreatedDto,
    BackgroundJobDto,
    BackgroundJobStatus,
    BackgroundJobSearchResult,
    BackgroundJobType,
    BackgroundJobTypeMetadataDto,
    StartManualBackgroundJobDto
} from '@travel-planner/library-travel-planner-api';

export const BackgroundJobsActions = createActionGroup({
    source: 'Background Jobs',
    events: {
        'Load Background Jobs': props<{
            status?: BackgroundJobStatus | undefined;
            jobType?: BackgroundJobType | undefined;
            relatedEntityType?: string | undefined;
            includeTotal?: boolean | undefined;
            limit?: number | undefined;
            skipLoadingIndicator?: boolean | undefined;
        }>(),
        'Load Background Jobs Success': props<{ result: BackgroundJobSearchResult }>(),
        'Load Background Jobs Failure': props<{ error: unknown }>(),
        'Load Background Job Types': props<{ skipLoadingIndicator?: boolean | undefined }>(),
        'Load Background Job Types Success': props<{ jobTypes: BackgroundJobTypeMetadataDto[] }>(),
        'Load Background Job Types Failure': props<{ error: unknown }>(),
        'Start Manual Background Job': props<{ request: StartManualBackgroundJobDto }>(),
        'Start Manual Background Job Success': props<{ job: BackgroundJobCreatedDto }>(),
        'Start Manual Background Job Failure': props<{ error: unknown }>(),
        'Register Job': props<{ job: BackgroundJobCreatedDto; relatedEntityId?: number | null }>(),
        'Job Polling Started': props<{ jobId: string }>(),
        'Start Polling Job': props<{ jobId: string }>(),
        'Resume Polling For Entity Jobs': props<{ relatedEntityId: number; jobType?: BackgroundJobType }>(),
        'Job Status Updated': props<{ job: BackgroundJobDto }>(),
        'Job Completed': props<{ job: BackgroundJobDto }>(),
        'Job Failed': props<{ job: BackgroundJobDto }>(),
        'Job Polling Failed': props<{ jobId: string; error: unknown }>(),
        'Job Polling Timed Out': props<{ jobId: string }>(),
    }
});
